import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';
import classes from '../script.module.scss';
import Modal from '../../../../_common/Modal/Modal';
import SortpakLogo from '../../../../../assets/icons/sortpak-logo-fax.png';
import PaymentTable from './PaymentTable/PaymentTable';
import api from '../../../../../api/api';
import Loader from '../../../../_common/Loader/Loader';

const PaymentSuccessModal = ({ paymentData, scriptData, onClose }) => {
  const { totalAmount, transaction, payments } = paymentData;

  const {
    Patient, dob, phone, rxNumber,
  } = scriptData;

  const patientName = `${Patient?.firstName} ${Patient?.lastName}`;
  const address = _.compact([Patient?.addressCity, Patient?.addressState, Patient?.addressZipCode]);

  const [isFileUploaded, fileUploadToggle] = useState(false);

  const uploadToSthree = async () => {
    try {
      const input = document.getElementById('divToPrint');

      const canvas = await html2canvas(input);

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 208;
      const pageHeight = 295;
      const imgHeight = Math.floor((canvas.height * imgWidth) / canvas.width);
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position += heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      const receipt = pdf.output('blob');

      const formData = new FormData();

      formData.append('attachmentFile', receipt); // attachmentFile in use in sthree-route

      const fileName = `receipt-${transaction?.receiptId || 1}.pdf`;
      const { data } = await api.uploadToSthree(formData, fileName, transaction.receiptId);

      if (data === 'Access Denied') {
        toast.error('Access Denied!');
      } else {
        toast.success('Your receipt was saved');
      }
    } catch (e) {
      toast.error('Attachment unsuccessful');
    }

    fileUploadToggle(true);
  };

  useEffect(() => {
    const timeout = setTimeout(() => uploadToSthree(), 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Modal
      open={!_.isEmpty(paymentData)}
      onClose={isFileUploaded ? onClose : null}
      className={classes.payment_success_modal}
    >
      <div className={classes.payment_success_modal_wrapper}>
        {!isFileUploaded && <Loader className={classes.payment_loader} size={20} />}
        <div
          id="divToPrint"
          className={classes.payment_success_modal_content}
          style={{
            background: '#fff',
            width: '210mm',
            minHeight: '297mm',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <div className={classes.main}>
            <div className={classes.info}>
              <img
                alt="SortPak"
                src={SortpakLogo}
              />

              <div>
                <h2>RECEIPT</h2>

                <p>
                  PRINTED ON
                  {moment().format('MM/DD/YYYY')}
                </p>
              </div>

              <div className={classes.address}>
                655 N Central Ave 22nd Floor
                <br />
                Glendale, Ca 91203
                <br />
                TEL: (877) 570-7787
                <br />
                FAX: (877) 475-2382
              </div>
            </div>

            <br />
            <br />

            <table className={classes.info_table}>
              <tbody>
                <tr>
                  <td>NAME</td>
                  <td>{patientName}</td>

                  <td>DATE OF BIRTH</td>
                  <td>{moment(dob).format('MM/DD/YYYY')}</td>
                </tr>

                <tr>
                  <td>RX NUMBER</td>
                  <td>{rxNumber}</td>

                  <td>PHONE</td>
                  <td>{phone}</td>
                </tr>

                <tr>
                  <td>PATIENT COPAY</td>
                  <td>{totalAmount}</td>

                  <td>ADDRESS</td>
                  <td>
                    {Patient?.addressStreet ? `${Patient.addressStreet},` : ''}
                    <br />
                    {!_.isEmpty(address) && address.join(', ')}
                  </td>
                </tr>

                <tr>
                  <td>TRANSACTION ID</td>

                  <td>{transaction?.transactionId}</td>
                </tr>
              </tbody>
            </table>
            <br />

            <PaymentTable payments={payments || []} totalAmount={totalAmount || '0'} />

            <div className={classes.signatures}>
              <div>
                <p className={classes.signatures_title}>SIGNATURE</p>

                <p>__________________________</p>
              </div>
            </div>

            <div className={classes.confidentiality}>
              <h5>CONFIDENTIALITY NOTICE</h5>

              <p>
                The information contained in this transmittal belongs to SortPak Pharmacy and may
                include information that is confidential, privileged, and protected from disclosure under
                applicable law. It is intended only for the use of the above physicians. If you are not the
                intended recipient of this information, you are hereby notified that any disclosure, copying,
                or distribution of this information is strictly prohibited. If you have received this transmittal
                in error, please immediately notify us by telephone at (877) 570-7787. Thank you.
              </p>
            </div>

          </div>
        </div>
      </div>
    </Modal>
  );
};

PaymentSuccessModal.propTypes = {
  paymentData: PropTypes.object.isRequired,
  scriptData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PaymentSuccessModal;
